import { EntityService } from '../../core/services/entity.service';
import { GlobalService } from '../../core/services/global.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { Driver } from '../model/driver';
import { DriverList } from '../model/driver-list';
import { DriverExpData } from '../model/exports/driverExpData';

@Injectable()
export class DriverService {

    constructor(private http: GlobalService, private entityService: EntityService) {
    }

    getByDocument(documentType: number, documentNumber: number): Observable<Driver> {
        const url = `drivers/${documentType}/${documentNumber}`;
        return this.http.get(url)
            .map(res => this.entityService.extractData<Driver>(res))
            .map(dataItem => this.entityService.copy(dataItem, new Driver()));
    }

    getByFile(driverFile: string): Observable<Driver> {
        const url = `drivers/${driverFile}`;
        return this.http.get(url)
            .map(res => this.entityService.extractData<Driver>(res))
            .map(dataItem => this.entityService.copy(dataItem, new Driver()));
    }

    getFullDrivers(ids: number[]): Observable<DriverExpData[]> {
        const url = `drivers/full`;
        return this.http.put(url, ids)
            .map(res => {
                console.log(res);
                return this.entityService.extractData<DriverExpData[]>(res);
            }).map(data => {
                return data.map(dataItem => this.entityService.copy(dataItem, new DriverExpData()));
            });
    }

    getAll(): Observable<DriverList[]> {
        const url = `drivers/all`;
        return this.http.get(url)
            .map(res => this.entityService.extractData<DriverList[]>(res))
            .map(data => {
                return data.map(dataItem => {
                    const driver = new DriverList(dataItem.startInBussiness, dataItem.licenseExpiration);
                    return this.entityService.copy(dataItem, driver);
                });
            });
    }

    add(driver: Driver): Observable<boolean> {
        const url = `drivers`;
        return this.http.post(url, driver)
            .map(res => this.entityService.extractData<boolean>(res));
    }

    update(driver: Driver): Observable<boolean> {
        const url = `drivers`;
        return this.http.put(url, driver)
            .map(res => this.entityService.extractData<boolean>(res));
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/driver.service.ts